import {useApiHealthStatus} from "@contexts/hooks/api/useApiHealthStatus.ts";
import {SignalWifiBad, Wifi} from "@mui/icons-material";
import {IconButton, Tooltip} from "@mui/material";
import dayjs, {Dayjs} from "dayjs";
import {useMemo, useState} from "react";

export function HealthCheckIcon() {
    const {
        healthStatus
    } = useApiHealthStatus()

    const {
        api,
        database,
        lastUpdate,
        backendVersion,
        frontendVersion
    } = healthStatus

    const hasError = api === 'Unhealthy' || database === 'Unhealthy'
    const hasWarning = api === 'Degraded' || database === 'Degraded'
    const hasSuccess = api === 'Healthy' && database === 'Healthy'

    const [lastHover, setLastHover] = useState<Dayjs>(dayjs());


    const color = hasError ? 'error' : hasWarning ? 'warning' : hasSuccess ? 'success' : 'inherit';

    const tooltip = useMemo(() => {
        return `API Status: ${api}, Database Status: ${database}, Versão do backend: ${backendVersion}, Versão do frontend: ${frontendVersion} Ultimo Check: ${dayjs(dayjs()).diff(lastUpdate, 'second')}s atrás`
    }, [lastHover])

    return (
        <Tooltip title={tooltip} onMouseOver={() => {
            setLastHover(dayjs())
        }}>
            <IconButton color={color} aria-label="Health Check Status" size="large">
                {color === 'error' && <SignalWifiBad color={'error'}/> || <Wifi color={color}/>}
            </IconButton>
        </Tooltip>)
}
